<ng-container *ngIf="hasData">
    <app-dc-pane
        *ngIf="backtestedProbabilityOfLossData"
        class="backtestedProbabilityOfLoss"
        [lightBackground]="true"
        [tableContainer]="true"
        [noScroll]="true"
        [loading]="loading"
        [headerDateStringRight]="backFvcAsOfDate"
    >
        <ng-container class="heading"
            >Backtested Probability of Loss (%)</ng-container
        >
        <app-dc-table
            rowHeight="auto"
            #table
            class="no-footer"
            [columns]="columns.backtestedProbabilityOfLoss"
            [rows]="backtestedProbabilityOfLossData"
            [messages]="messages"
        >
        </app-dc-table>
    </app-dc-pane>

    <app-dc-pane
        *ngIf="forwardLookingProbabilityOfLossData"
        class="forwardLookingProbabilityOfLoss"
        [lightBackground]="true"
        [tableContainer]="true"
        [noScroll]="true"
        [loading]="loading"
        [headerDateStringRight]="forwardFvcAsOfDate"
    >
        <ng-container class="heading"
            >Forward Looking Probability of Loss (%)</ng-container
        >
        <app-dc-table
            rowHeight="auto"
            #table
            class="no-footer"
            [columns]="columns.forwardLookingProbabilityOfLoss"
            [rows]="forwardLookingProbabilityOfLossData"
            [messages]="messages"
        >
        </app-dc-table>
    </app-dc-pane>

    <app-dc-pane
        *ngIf="riskRewardData"
        class="riskReward"
        [lightBackground]="true"
        [tableContainer]="true"
        [noScroll]="true"
        [loading]="loading"
        [headerDateStringRight]="riskRewardFvcAsOfDate"
    >
        <ng-container class="heading">Risk Reward</ng-container>
        <app-dc-table
            rowHeight="auto"
            #table
            class="no-footer"
            [columns]="columns.riskReward"
            [rows]="riskRewardData"
            [messages]="messages"
        >
        </app-dc-table>
    </app-dc-pane>

    <app-dc-pane
        *ngIf="valueForMoneyFVCData"
        class="valueForMoneyFVC"
        [lightBackground]="true"
        [tableContainer]="true"
        [noScroll]="true"
        [loading]="loading"
        [headerDateStringRight]="valueForMoneyFVCAsOfDate"
    >
        <ng-container class="heading">{{ valueForMoneyHeader }}</ng-container>
        <ng-container class="sub-heading">{{ valueForMoneySubHeader }}</ng-container>
        <app-dc-table
            rowHeight="auto"
            #table
            class="no-footer"
            [columns]="columns.valueForMoneyFVC"
            [rows]="valueForMoneyFVCData"
            [messages]="messages"
        >
        </app-dc-table>
    </app-dc-pane>

    <app-dc-pane
        *ngIf="backTestingData"
        class="backTesting"
        [lightBackground]="true"
        [tableContainer]="true"
        [noScroll]="true"
        [loading]="loading"
        [headerDateStringRight]="backFvcAsOfDate"
    >
        <ng-container class="heading">Back Testing</ng-container>
        <app-dc-table
            rowHeight="auto"
            #table
            class="no-footer"
            [columns]="columns.backTestingData"
            [rows]="backTestingData"
            [messages]="messages"
        >
        </app-dc-table>
    </app-dc-pane>

    <app-dc-pane
        *ngIf="forwardTestingData"
        class="forwardTesting"
        [lightBackground]="true"
        [tableContainer]="true"
        [noScroll]="true"
        [loading]="loading"
        [headerDateStringRight]="forwardFvcAsOfDate"
    >
        <ng-container class="heading">Forward Testing</ng-container>
        <app-dc-table
            rowHeight="auto"
            #table
            class="no-footer"
            [columns]="columns.forwardTestingData"
            [rows]="forwardTestingData"
            [messages]="messages"
        >
        </app-dc-table>
    </app-dc-pane>

    <app-dc-pane
        *ngIf="probabilityOfReturnsData"
        class="probabilityOfReturns"
        [lightBackground]="true"
        [tableContainer]="true"
        [noScroll]="true"
        [loading]="loading"
        [headerDateStringRight]="performanceFvcAsOfDate">
        <ng-container class="heading">Probability Of Returns (%)</ng-container>
        <app-dc-table
            rowHeight="auto"
            #table
            class="no-footer"
            [columns]="columns.probabilityOfReturns"
            [rows]="probabilityOfReturnsData"
            [messages]="messages">
        </app-dc-table>
    </app-dc-pane>

    <app-dc-pane
        *ngIf="probabilityOfLossData"
        class="probabilityOfLoss"
        [lightBackground]="true"
        [tableContainer]="true"
        [noScroll]="true"
        [loading]="loading"
        [headerDateStringRight]="forwardCloudRiskAsOfDate">
        <ng-container class="heading">Probability Of Loss (%)</ng-container>
        <app-dc-table
            rowHeight="auto"
            #table
            class="no-footer"
            [columns]="columns.probabilityOfLoss"
            [rows]="probabilityOfLossData"
            [messages]="messages">
        </app-dc-table>
    </app-dc-pane>

    <app-dc-pane
        *ngIf="valueForMoneyCloudRiskData"
        class="valueForMoneyCloudRisk"
        [lightBackground]="true"
        [tableContainer]="true"
        [noScroll]="true"
        [loading]="loading"
        [headerDateStringRight]="valueForMoneyCloudRiskAsOfDate">
        <ng-container class="heading">{{ valueForMoneyHeader }}</ng-container>
        <ng-container class="sub-heading">{{ valueForMoneySubHeader }}</ng-container>
        <app-dc-table
            rowHeight="auto"
            #table
            class="no-footer"
            [columns]="columns.valueForMoneyCloudRisk"
            [rows]="valueForMoneyCloudRiskData"
            [messages]="messages"
        >
        </app-dc-table>
    </app-dc-pane>
</ng-container>
<app-analytics-report-state></app-analytics-report-state>